import React from "react";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import AddItemBtn from "Common/Custom/AddItemBtn";
import BrandLogoListTable from "./Componates/BrandLogoListTable";

const BrandLogoListList = () => {
  return (
    <PageBody
      card={true}
      headerchildren={
        <>
          <HeadingOne>Brand Logo List</HeadingOne>
          <AddItemBtn url="add-brand-logo" title="Create" />
        </>
      }
    >
      {/* Table section */}
      <div className="col-12">
        <BrandLogoListTable />
      </div>
    </PageBody>
  );
};

export default BrandLogoListList;
